import { useCurrentProfile } from '@/lib/api/useCurrentProfile'
import { useAuth } from './useAuth'

/* ------------------------------------------------------------------ */
/*  useRole — returns current user's role from profiles table           */
/*  Derives role from the shared useCurrentProfile query to avoid       */
/*  redundant API calls (both query the same profiles row).            */
/*  See ARCHITECTURE.md §5                                             */
/* ------------------------------------------------------------------ */

export type UserRole = 'customer' | 'provider' | 'admin'

export interface UseRoleReturn {
  role: UserRole | null
  isLoading: boolean
  isError: boolean
}

export function useRole(): UseRoleReturn {
  const { isLoading: authLoading, isAuthenticated } = useAuth()
  const { data: profile, isLoading: profileLoading, isError } = useCurrentProfile()

  return {
    role: isAuthenticated && profile ? ((profile.role as UserRole) ?? null) : null,
    isLoading: authLoading || profileLoading,
    isError,
  }
}
